module.exports = __webpack_public_path__ + "img/zhifubao.d46dd86c.svg";